import type { AiBusinessCenterModule } from '../types'

/** 党建管理独立应用配置。 */
export const partyModule: AiBusinessCenterModule = {
  key: 'party',
  label: '党建管理',
  desc: '党组织/党员/组织关系/发展党员/组织生活/党费/教育/评议/考核',
  path: '/party',
  homePath: '/party/member',
  icon: 'ep:flag',
  color: '#ef4444'
}
